import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DataEntity } from 'src/app/models/data-entities';
import { ApplicantDataExternalSourceConfig, ExternalDataSource } from 'src/app/models/external-data-source';

@Component({
    selector: 'wm-applicant-data-external-source-config',
    templateUrl: './applicant-data-external-source-config.component.html',
    styleUrl: './applicant-data-external-source-config.component.css',
    standalone: false
})
export class ApplicantDataExternalSourceConfigComponent {
  @Input() form: UntypedFormGroup;
  @Input() externalDataSource: ExternalDataSource;
  @Input() entity: DataEntity;

  @Output() externalSourceUpdated: EventEmitter<any> = new EventEmitter<any>(); 

  sourceConfig: ApplicantDataExternalSourceConfig;
  applicantExternalDataFieldCtrl: AbstractControl;

  constructor(
    private _ref: ChangeDetectorRef,
    private _fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    if (this.entity.externalDataSource) {
      // it's possible the saved ExternalDataSource is no longer a valid option in the design.
      // Workflow validation will catch that, just keep it from erroring here.
      if (this.externalDataSource) {
        this.sourceConfig = this.externalDataSource.sourceConfig as ApplicantDataExternalSourceConfig;

        // apply any existing selections from the entity.externalDataSource 
        if ((this.entity.externalDataSource.sourceConfig as ApplicantDataExternalSourceConfig).selectedOption != null) {
          (this.externalDataSource.sourceConfig as ApplicantDataExternalSourceConfig).selectedOption = 
            (this.externalDataSource.sourceConfig as ApplicantDataExternalSourceConfig).options
              .find(o =>
                o.templateCode.toLocaleLowerCase() ===
                (this.entity.externalDataSource.sourceConfig as ApplicantDataExternalSourceConfig)
                  .selectedOption.templateCode.toLocaleLowerCase()
              );
        }
      }
    }

    this.form.addControl(
      'applicantExternalDataField',
      this._fb.control('', Validators.required)
    );

    this.applicantExternalDataFieldCtrl = this.form.controls[
      'applicantExternalDataField'
    ];
  }

  ngAfterViewChecked() {
    this._ref.detectChanges();
  }

  ngOnDestroy() {
    // this seems to be necessary for controls with custom validator functions
    this.form.removeControl('applicantExternalDataField');
  }

  handleChanges() {
    this.externalSourceUpdated.emit();

    this.setValidators();
  }

  setValidators() {
    this.applicantExternalDataFieldCtrl.clearValidators();

    this.form.get('applicantExternalDataField').updateValueAndValidity();

    this.applicantExternalDataFieldCtrl.setValidators(
      Validators.required
    );
  }
}
